import React from "react";
import { FaPlug } from "react-icons/fa";

const NoDevice = () => {
  return (
    <div className="flex flex-col items-center justify-center h-64 bg-gray-50 rounded-xl shadow p-6 animate-fadeIn">
      <div className="text-6xl text-gray-300 mb-4 animate-bounce">
        <FaPlug />
      </div>
      <h3 className="text-xl font-semibold text-gray-700 mb-2">
        No Devices Found
      </h3>
      <p className="text-gray-500 text-center max-w-xs">
        Looks like you haven't added any devices yet. Once devices are added, you'll see their stats here.
      </p>
    </div>
  );
};

export default NoDevice;
